import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root:{
    fill: 'currentColor',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexShrink: 0,
    userSelect: 'none'
  },
  white:{
    fill: theme.palette.white
  },
  black:{
    fill: theme.palette.black
  },
  yellow:{
    fill: theme.palette.yellow
  },
  purple:{
    fill: theme.palette.purple
  },
  darkPurple:{
    fill: theme.palette.darkPurple
  }
}));
const selectbox = (value) => {
  switch(value){
    case "downArrow":
    case "leftArrow":
    case "rightArrow":
    case "upArrow":
    case "facebook":
    case "twitter":
    case "instagram":
    case "circleCheck":
    case "comment":
    case "circleX":
    case "user":
      return "0 0 32 32"
    case "mail":
    case "check":
      return "0 0 32 24"
    case "x":
      return "0 0 24 24"
    case "caretUp":
    case "caretDown":
      return "0 0 32 18"
    case "menu":
    case "menuClose":
    case "youtube":
    case "tiktok":
      return "3 3 32 34"
    case "search":
      return "0 0 21.997 21.998"
    case "play":
      return "0 0 41 41"
    case "playArrow":
      return "0 0 28 40.25"
    case "pause":
      return "0 0 32 32"
    default:
      return "0 0 32 32"
  }
};

const selectIcon = (value) => {
  switch(value){
    case "downArrow":
      return <path d="M30.254 15.856l1.627 1.586a1.677 1.677 0 0 1 0 2.421L17.643 33.746a1.784 1.784 0 0 1-2.484 0L.914 19.862a1.677 1.677 0 0 1 0-2.421l1.627-1.586a1.793 1.793 0 0 1 2.513.029l8.412 8.606V3.964a1.733 1.733 0 0 1 1.759-1.714h2.345a1.733 1.733 0 0 1 1.759 1.714V24.49l8.412-8.606a1.78 1.78 0 0 1 2.513-.029z" transform="translate(-.397 -2.25)"/>
    case "leftArrow":
      return <path d="M18.391 32.5l-1.586 1.627a1.677 1.677 0 0 1-2.421 0L.5 19.893a1.784 1.784 0 0 1 0-2.484L14.384 3.164a1.677 1.677 0 0 1 2.421 0l1.586 1.627a1.793 1.793 0 0 1-.029 2.509l-8.606 8.416h20.526A1.733 1.733 0 0 1 32 17.475v2.345a1.733 1.733 0 0 1-1.714 1.759H9.756l8.606 8.412a1.78 1.78 0 0 1 .029 2.509z" transform="translate(.004 -2.647)"/>
    case "rightArrow":
      return <path d="M13.606 4.791l1.586-1.627a1.677 1.677 0 0 1 2.421 0L31.5 17.4a1.784 1.784 0 0 1 0 2.484L17.612 34.131a1.677 1.677 0 0 1-2.421 0L13.606 32.5a1.793 1.793 0 0 1 .029-2.513l8.606-8.412H1.714A1.733 1.733 0 0 1 0 19.82v-2.345a1.733 1.733 0 0 1 1.714-1.759H22.24L13.634 7.3a1.78 1.78 0 0 1-.028-2.509z" transform="translate(0 -2.647)"/>
    case "upArrow":
      return <path d="M2.541 20.641L.914 19.055a1.676 1.676 0 0 1 0-2.421L15.155 2.75a1.784 1.784 0 0 1 2.485 0l14.241 13.877a1.676 1.676 0 0 1 0 2.421l-1.627 1.586a1.794 1.794 0 0 1-2.514-.029l-8.407-8.6v20.527a1.733 1.733 0 0 1-1.759 1.714h-2.346a1.733 1.733 0 0 1-1.759-1.714V12.006l-8.414 8.606a1.78 1.78 0 0 1-2.514.029z" transform="translate(-.397 -2.246)"/>
    case "facebook":
      return <path d="M28.571 2.25H3.429A3.429 3.429 0 0 0 0 5.679v25.142a3.429 3.429 0 0 0 3.429 3.429h9.8V23.371h-4.5V18.25h4.5v-3.9c0-4.439 2.643-6.891 6.691-6.891a27.262 27.262 0 0 1 3.966.346v4.357h-2.231a2.561 2.561 0 0 0-2.887 2.766v3.322h4.913l-.781 5.121h-4.132V34.25h9.8A3.429 3.429 0 0 0 32 30.821V5.679a3.429 3.429 0 0 0-3.429-3.429z" transform="translate(0 -2.25)"/>
    case "twitter":
      return <path d="M19.044,13.848,30.957,0H28.134L17.79,12.024,9.529,0H0L12.493,18.182,0,32.7H2.823l10.923-12.7,8.725,12.7H32L19.044,13.848Zm-3.867,4.495-1.266-1.811L3.84,2.125H8.176L16.3,13.752l1.266,1.811L28.135,30.675H23.8L15.178,18.343Z"/>
    case "instagram":
      return <path d="M16 10.033a8.2 8.2 0 1 0 8.2 8.2 8.19 8.19 0 0 0-8.2-8.2zm0 13.538a5.334 5.334 0 1 1 5.333-5.334A5.343 5.343 0 0 1 16 23.572zM26.45 9.7a1.913 1.913 0 1 1-1.913-1.914A1.909 1.909 0 0 1 26.45 9.7zm5.433 1.942a9.471 9.471 0 0 0-2.584-6.7 9.529 9.529 0 0 0-6.7-2.585c-2.641-.15-10.558-.15-13.2 0a9.515 9.515 0 0 0-6.7 2.578 9.5 9.5 0 0 0-2.584 6.7c-.15 2.642-.15 10.561 0 13.2a9.471 9.471 0 0 0 2.584 6.7 9.541 9.541 0 0 0 6.7 2.585c2.641.15 10.558.15 13.2 0a9.467 9.467 0 0 0 6.7-2.585 9.534 9.534 0 0 0 2.584-6.7c.15-2.642.15-10.554 0-13.2zM28.47 27.67a5.4 5.4 0 0 1-3.041 3.042c-2.106.835-7.1.643-9.43.643s-7.332.186-9.43-.643a5.4 5.4 0 0 1-3.042-3.042c-.835-2.106-.642-7.1-.642-9.433S2.7 10.9 3.527 8.805a5.4 5.4 0 0 1 3.041-3.042c2.106-.835 7.1-.643 9.43-.643s7.332-.186 9.43.643a5.4 5.4 0 0 1 3.042 3.042c.835 2.106.642 7.1.642 9.433s.193 7.333-.642 9.432z" transform="translate(.005 -2.238)"/>
    case "mail":
      return <path d="M31.394 12.425a.376.376 0 0 1 .606.294V25.5a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V12.725a.374.374 0 0 1 .606-.294c1.4 1.088 3.256 2.469 9.631 7.1 1.319.963 3.544 2.987 5.762 2.975 2.231.019 4.5-2.05 5.769-2.975 6.376-4.631 8.226-6.018 9.626-7.106zM16 20.5c1.45.025 3.538-1.825 4.588-2.587 8.294-6.019 8.925-6.544 10.837-8.044A1.5 1.5 0 0 0 32 8.687V7.5a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v1.188a1.5 1.5 0 0 0 .575 1.181c1.913 1.494 2.544 2.025 10.838 8.044 1.049.762 3.137 2.612 4.587 2.587z" transform="translate(0 -4.5)"/>
    case "circleCheck":
      return <path d="M32.563 16.563a16 16 0 1 1-16-16 16 16 0 0 1 16 16zm-17.851 8.471l11.871-11.871a1.032 1.032 0 0 0 0-1.46l-1.46-1.46a1.032 1.032 0 0 0-1.46 0l-9.681 9.681-4.52-4.52a1.032 1.032 0 0 0-1.46 0l-1.46 1.46a1.032 1.032 0 0 0 0 1.46l6.71 6.71a1.032 1.032 0 0 0 1.46 0z" transform="translate(-.563 -.563)"/>
    case "check":
      return <path d="M10.869 27.971l-10.4-10.4a1.6 1.6 0 0 1 0-2.263l2.263-2.263a1.6 1.6 0 0 1 2.263 0L12 20.052 27.006 5.046a1.6 1.6 0 0 1 2.263 0l2.263 2.263a1.6 1.6 0 0 1 0 2.263l-18.4 18.4a1.6 1.6 0 0 1-2.263-.001z" transform="translate(0 -4.577)"/>
    case "comment":
      return <path d="M28 0H4a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h6v5.25a.752.752 0 0 0 1.194.606L19 26h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4z"/>
    case "x":
      return <path d="M16.549 17.625l6.823-6.825a2.145 2.145 0 0 0 0-3.033l-1.516-1.514a2.145 2.145 0 0 0-3.033 0L12 13.076 5.177 6.253a2.145 2.145 0 0 0-3.033 0L.628 7.769a2.145 2.145 0 0 0 0 3.033l6.823 6.823-6.823 6.823a2.145 2.145 0 0 0 0 3.033L2.144 29a2.145 2.145 0 0 0 3.033 0L12 22.174 18.823 29a2.145 2.145 0 0 0 3.033 0l1.516-1.516a2.145 2.145 0 0 0 0-3.033z" transform="translate(0 -5.625)"/>
    case "circleX":
      return <path d="M16.563.563a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm7.845 20.2a.775.775 0 0 1 0 1.1l-2.555 2.548a.775.775 0 0 1-1.1 0l-4.194-4.232-4.2 4.232a.775.775 0 0 1-1.1 0l-2.542-2.558a.775.775 0 0 1 0-1.1l4.232-4.194-4.232-4.2a.775.775 0 0 1 0-1.1l2.555-2.555a.775.775 0 0 1 1.1 0l4.194 4.239 4.2-4.232a.775.775 0 0 1 1.1 0l2.555 2.555a.775.775 0 0 1 0 1.1l-4.239 4.194z" transform="translate(-.563 -.563)"/>
    case "user":
      return <path d="M16 .563a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0 6.194a5.677 5.677 0 1 1-5.677 5.677A5.678 5.678 0 0 1 16 6.756zm0 22.193a12.363 12.363 0 0 1-9.452-4.4 7.193 7.193 0 0 1 6.352-3.858 1.579 1.579 0 0 1 .458.071 8.542 8.542 0 0 0 2.642.445 8.51 8.51 0 0 0 2.639-.445 1.579 1.579 0 0 1 .458-.071 7.193 7.193 0 0 1 6.355 3.858A12.363 12.363 0 0 1 16 28.95z" transform="translate(0 -.563)"/>
    case "caretUp":
      return <path d="M30.638 30.891H2.951a2.132 2.132 0 0 1-1.522-3.644l13.844-13.731a2.165 2.165 0 0 1 3.043 0L32.16 27.247a2.132 2.132 0 0 1-1.522 3.644z" transform="translate(-.794 -12.891)"/>
    case "caretDown":
      return <path d="M2.947 13.5h27.694a2.128 2.128 0 0 1 1.518 3.639L18.317 30.876a2.17 2.17 0 0 1-3.046 0L1.43 17.139A2.128 2.128 0 0 1 2.947 13.5z" transform="translate(-.794 -13.5)"/>
    case "menu":
      return <path d="M1.143 9.362h29.714A1.143 1.143 0 0 0 32 8.219V5.362a1.143 1.143 0 0 0-1.143-1.143H1.143A1.143 1.143 0 0 0 0 5.362v2.857a1.143 1.143 0 0 0 1.143 1.143zm0 11.429h29.714A1.143 1.143 0 0 0 32 19.647V16.79a1.143 1.143 0 0 0-1.143-1.143H1.143A1.143 1.143 0 0 0 0 16.79v2.857a1.143 1.143 0 0 0 1.143 1.143zm0 11.429h29.714A1.143 1.143 0 0 0 32 31.076v-2.857a1.143 1.143 0 0 0-1.143-1.143H1.143A1.143 1.143 0 0 0 0 28.219v2.857a1.143 1.143 0 0 0 1.143 1.143z" transform="translate(-811.55 -231.219) translate(815.55 233)"/>
    case "menuClose":
      return <g>
                <path fill="#fff" d="M0 0H40V40H0z" opacity="0.001" transform="translate(-814.891 -234.56) translate(814.891 234.56)"/>
                <path fill="#f8df10" d="M2659.453-2593.95l-10.98-10.98-10.98 10.98a1.444 1.444 0 0 1-2.043 0l-2.554-2.554a1.445 1.445 0 0 1 0-2.043l10.98-10.98-10.98-10.98a1.445 1.445 0 0 1 0-2.043l2.554-2.554a1.444 1.444 0 0 1 2.043 0l10.98 10.98 10.98-10.98a1.444 1.444 0 0 1 2.043 0l2.554 2.554a1.444 1.444 0 0 1 0 2.043l-10.98 10.98 10.98 10.98a1.444 1.444 0 0 1 0 2.043l-2.554 2.554a1.44 1.44 0 0 1-1.021.423 1.44 1.44 0 0 1-1.022-.423z" transform="translate(-814.891 -234.56) translate(-1813.582 2864.087)"/>
              </g>
    case "play":
      return <path strokeMiterlimit="10" d="M-5314.03-1588.475a20 20 0 0 1 20-20 20 20 0 0 1 20 20 20 20 0 0 1-20 20 20 20 0 0 1-20-20zm3.479 0a16.54 16.54 0 0 0 16.521 16.522 16.54 16.54 0 0 0 16.521-16.522A16.54 16.54 0 0 0-5294.03-1605a16.54 16.54 0 0 0-16.522 16.525zm11.739 8.123v-16.255c0-1.632 1.36-2.272 2.248-1.612l10.933 8.129a2.044 2.044 0 0 1 .2.2 2.143 2.143 0 0 1-.2 3.023l-10.933 8.124a1.251 1.251 0 0 1-.756.264 1.709 1.709 0 0 1-1.492-1.873z" transform="translate(5314.53 1608.975)"/>
    case "playArrow":
      return <path d="M26.526,16.877,4.525.519C2.738-.81,0,.479,0,3.765v32.71c0,2.948,2.544,4.724,4.525,3.247l22-16.351A4.312,4.312,0,0,0,26.526,16.877Z" transform="translate(0 -0.002)"/>
    case "pause":
      return <path
                d="M10.286,63H3.429A3.429,3.429,0,0,1,0,59.571V34.429A3.429,3.429,0,0,1,3.429,31h6.857a3.429,3.429,0,0,1,3.429,3.429V59.571A3.429,3.429,0,0,1,10.286,63ZM32,59.571V34.429A3.429,3.429,0,0,0,28.571,31H21.714a3.429,3.429,0,0,0-3.429,3.429V59.571A3.429,3.429,0,0,0,21.714,63h6.857A3.429,3.429,0,0,0,32,59.571Z" transform="translate(0 -31)"
              />
    case "youtube":
      return <path d="M28.571 32H3.429A3.433 3.433 0 0 1 0 28.571V3.429A3.433 3.433 0 0 1 3.429 0h25.142A3.433 3.433 0 0 1 32 3.429v25.142A3.433 3.433 0 0 1 28.571 32zM12 9.3v13.4L23.049 16z" transform="translate(-1403.373 2.131) translate(1407.373 1.869)"/>
    case "tiktok":
      return <path d="M17.293.027C19.078 0 20.85.014 22.622 0a8.6 8.6 0 0 0 2.385 5.734 9.568 9.568 0 0 0 5.778 2.461v5.541a14.48 14.48 0 0 1-5.724-1.336 16.8 16.8 0 0 1-2.208-1.279c-.014 4.015.014 8.03-.027 12.031a10.564 10.564 0 0 1-1.84 5.417 10.131 10.131 0 0 1-8.054 4.414 9.869 9.869 0 0 1-5.56-1.416A10.377 10.377 0 0 1 2.4 23.718c-.027-.687-.041-1.375-.014-2.049A10.349 10.349 0 0 1 5.9 14.85a10.082 10.082 0 0 1 8.381-2.365c.027 2.035-.055 4.07-.055 6.1A4.669 4.669 0 0 0 8.257 21.5a5.5 5.5 0 0 0-.191 2.214 4.649 4.649 0 0 0 4.77 3.946 4.571 4.571 0 0 0 3.775-2.214 3.189 3.189 0 0 0 .559-1.457c.136-2.461.082-4.909.1-7.37.014-5.541-.014-11.069.027-16.6z" transform="translate(-1331.373 2.131) translate(1334.795 1.369)"/>
    case "search":
      return (
        <path d="M834.827,448.289a10.126,10.126,0,1,0,5.858,18.377.935.935,0,0,0,.078.09L844.009,470a.971.971,0,0,0,1.373,0l1.032-1.032a.971.971,0,0,0,0-1.373l-3.247-3.246a.928.928,0,0,0-.09-.079,10.117,10.117,0,0,0-8.251-15.984Zm6.725,10.126a6.725,6.725,0,1,1-6.725-6.725A6.733,6.733,0,0,1,841.552,458.415Z" transform="translate(-824.701 -448.289)" />
      )
    default:
      return <path d="M30.254 15.856l1.627 1.586a1.677 1.677 0 0 1 0 2.421L17.643 33.746a1.784 1.784 0 0 1-2.484 0L.914 19.862a1.677 1.677 0 0 1 0-2.421l1.627-1.586a1.793 1.793 0 0 1 2.513.029l8.412 8.606V3.964a1.733 1.733 0 0 1 1.759-1.714h2.345a1.733 1.733 0 0 1 1.759 1.714V24.49l8.412-8.606a1.78 1.78 0 0 1 2.513-.029z" transform="translate(-.397 -2.25)"/>
  }
};

export function TakisSvg(props) {
  const classes = useStyles();
  return (
    <svg
      className={`${classes.root} ${props.svg_class}`}
      viewBox={selectbox(props.icon)}
      aria-label={props.ariaLabel}
      aria-hidden={props.ariaHidden}
      role="img"
      >
      {selectIcon(props.icon)}
    </svg>
  );
}

TakisSvg.propTypes = {
  svg_class: PropTypes.string,
  viewbox: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaHidden: PropTypes.string,
  icon: PropTypes.string.isRequired
}

export function CaretSvg(props) {
  const classes = useStyles();
  return (
    <svg
      className={`${classes.root} ${props.svg_class}`}
      viewBox="0 0 32 18"
      aria-label={props.ariaLabel}
      aria-hidden={props.ariaHidden}
      >
      {props.state? selectIcon("caretUp"):selectIcon("caretDown")}
    </svg>
  );
}

export function MenuSvg(props) {
  const classes = useStyles();
  return (
    <svg
      className={`${classes.root} ${props.svg_class}`}
      viewBox="0 0 40 40"
      aria-hidden={props.ariaHidden}
      aria-label={props.ariaLabel}
      >
      {props.state? selectIcon("menu"):selectIcon("menuClose")}
    </svg>
  );
}

CaretSvg.propTypes = {
  svg_class: PropTypes.string,
  state: PropTypes.bool.isRequired,
  ariaHidden: PropTypes.string
}
